import {AppstoreApiKeyFormEnum, AppstoreApiKeyFormType} from './appstore-api-key-form/appstore-api-key-form-type';
import {AppstoreAppsFormEnum, AppstoreAppsFormType} from './appstore-apps-form/appstore-apps-form-type';

const APPSTORE_ISSUER_ID_UUID_REGEX = /^[\da-f]{8}(?:-[\da-f]{4}){3}-[\da-f]{12}$/iu;

/** Mirrors `validAppstoreIssuerIdRule` / `validAppstoreKeyIdRule` in form-rules-hook for footer button gating. */
export function isAppstoreApiKeyFormComplete(values: Partial<AppstoreApiKeyFormType>): boolean {
    const issuerId = String(values[AppstoreApiKeyFormEnum.issuerId] ?? '').trim();
    const keyId = String(values[AppstoreApiKeyFormEnum.keyId] ?? '').trim();
    const privateKey = values[AppstoreApiKeyFormEnum.privateKey];

    if (!issuerId || !APPSTORE_ISSUER_ID_UUID_REGEX.test(issuerId)) {
        return false;
    }

    if (!keyId || keyId.length !== 10) {
        return false;
    }

    return !(!privateKey || !(privateKey instanceof File));
}

/** Every brand row must have a brand and at least one app selected. */
export function isAppstoreAppsFormComplete(values: Partial<AppstoreAppsFormType> | undefined): boolean {
    const rows = values?.[AppstoreAppsFormEnum.brandApps];

    if (!Array.isArray(rows) || rows.length === 0) {
        return false;
    }

    return rows.every(
        (row) => row && typeof row.brandId === 'number' && Array.isArray(row.apps) && row.apps.length > 0
    );
}

/** Whether the last row in the list is ready so another brand row may be added. */
export function isLastAppstoreBrandAppsRowComplete(brandApps: unknown): boolean {
    if (!Array.isArray(brandApps) || brandApps.length === 0) {
        return false;
    }

    const last = brandApps[brandApps.length - 1] as {brandId?: unknown; apps?: unknown};

    return typeof last?.brandId === 'number' && Array.isArray(last?.apps) && last.apps.length > 0;
}
